import { CmsSubsidiary } from '@/components/CmsInterfaces';
import Table from '@/components/Table';
import { DeadlineCol } from '@/config/game';
import { getGameById } from '@/helpers/getGameById';
import { mapStateIdToName } from '@/helpers/mapStateIdToName';
import { useEffect, useState } from 'react';

export interface DeadlinesProps {
  game: string | number;
  hideCaption?: boolean;
}

const getRows = (
  subsidiaries: CmsSubsidiary[],
  deadlineCols: DeadlineCol[]
) => {
  const rows = subsidiaries;
  return rows
    ? rows
        .map((item) => {
          return deadlineCols.map((col) => {
            if (col.key === 'state') {
              return mapStateIdToName(item[col.key]);
            }
            return item[col.key] || '';
          });
        })
        .sort((a, b) => a[0].localeCompare(b[0]))
    : [];
};

const Deadlines = (props: DeadlinesProps) => {
  const [subsidiaries, setSubsidiaries] = useState<CmsSubsidiary[]>();

  useEffect(() => {
    async function fetchData() {
      const response = await fetch(`/api/data/subsidiaries`);
      if (response.ok) {
        setSubsidiaries(await response.json());
      }
    }
    fetchData();
  }, []);

  const config = getGameById(props.game);
  const deadlineCols = config ? config.deadlineCols || [] : [];
  const rowsHead = deadlineCols.map((item) => item.head);
  const theme = props.hideCaption !== true ? config : undefined;
  const caption = props.hideCaption !== true ? 'Annahmeschluss' : undefined;
  const footnote = 'Alle Angaben ohne Gewähr.';
  if (!subsidiaries) {
    return null;
  }
  const rows = getRows(subsidiaries, deadlineCols);
  if (!config) {
    return null;
  }
  return (
    <Table>
      <Table.Caption theme={theme} caption={caption} />
      <Table.Head rowsHead={rowsHead} />
      <Table.Body rows={rows} />
      <Table.FootNote footnote={footnote} />
    </Table>
  );
};

export default Deadlines;
